// BookingContext.js - Version mise à jour
import React, { createContext, useContext, useState } from "react";

const BookingContext = createContext();

export const BookingProvider = ({ children }) => {
  const [selectedTour, setSelectedTour] = useState(null);
  const [travelers, setTravelers] = useState(1);
  const [selectedDate, setSelectedDate] = useState("");

  // ✅ Calculer le prix total
  const totalPrice = selectedTour ? selectedTour.price * travelers : 0;

  // ✅ Fonction pour sélectionner un tour
  const selectTour = (tour) => {
    setSelectedTour(tour);
    setTravelers(1); // Reset travelers quand on change de tour
  };

  // ✅ Fonction pour réinitialiser la réservation
  const resetBooking = () => {
    setSelectedTour(null);
    setTravelers(1);
  };

  return (
    <BookingContext.Provider
      value={{
        selectedTour,
        setSelectedTour,
        travelers,
        setTravelers,
        selectedDate,
        setSelectedDate,
        totalPrice,
        selectTour,
        resetBooking,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error("useBooking must be used within a BookingProvider");
  }
  return context;
};
